import { render, staticRenderFns } from "./VChat.vue?vue&type=template&id=2ae4dee6"
import script from "./VChat.vue?vue&type=script&lang=js"
export * from "./VChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports